import React from 'react';
import Question from './Questions/Question';
import { safeJSONParse } from 'helpers/sf_utils';
import { Row, Col } from 'reactstrap';
import { ADDRESS_CONSTS, QUOTE_FUNNEL } from 'helpers/sf_constants';


const QuestionGroup = ({ question_group, onChangeEvent, index }) => {
  const handleChange = (val, index) => {
    let request_duplicate_pages = false;
    let raw_value = ''
    const new_questions = question_group?.questions?.map((question, idx) => {
      if (idx !== index) {
        if ([ADDRESS_CONSTS.CITY, ADDRESS_CONSTS.STATE, ADDRESS_CONSTS.ZIP].includes(question?.field_name)) {
          if (raw_value) {
            const parsed_val = JSON.parse(raw_value)
            const value = parsed_val?.[question?.field_name]
            return {
              ...question,
              value: value || null
            }
          }
        }
        return question;
      }
      if (question?.placeholder === 'Zip' && (!/^[0-9]*$/.test(val) || val.length > 5)) {
        return question;
      }
      if (question?.is_repeatable_question && question?.repeatable_type === "add_another_instance_prompt" && val.toLowerCase() === "yes") {
        request_duplicate_pages = true;
      }
      if (question?.question_type === QUOTE_FUNNEL.COMPONENT_TYPE.ADDRESS) {
        const parsed_val = JSON.parse(val)
        if (parsed_val?.fill_type == ADDRESS_CONSTS.AUTO) {
          raw_value = val
        } else {
          raw_value = ''
        }
        return {
          ...question,
          value: parsed_val?.address || null,
          request_duplicate_pages: request_duplicate_pages
        }
      }

      return {
        ...question,
        value: val,
        request_duplicate_pages: request_duplicate_pages
      }
    })
    onChangeEvent({
      ...question_group,
      request_duplicate_pages: new_questions?.map(q => q.request_duplicate_pages)?.reduce((a, b) => a || b),
      questions: new_questions
    })
  };
  return (
    <Row id={`quote-form-page-${index}`}>
      {(question_group?.questions || [])?.sort((a, b) => a.order - b.order)?.map((question, idx) => {
        const question_drop_down_values = safeJSONParse(question?.css, null)

        return (
          <Col md={question_drop_down_values?.column || 12} key={`question_group_${question?.field_name}_${idx}`}>
            <Question
              index={idx}
              question={question}
              onChangeEvent={(value) => {
                handleChange(value, idx);
              }}
            />
          </Col>
        )
      })}
    </Row>)
}

export default QuestionGroup;
